module.exports = __webpack_public_path__ + "img/miantiao.a9063917.png";